export const filterNulls = <T>(array: (T | null)[]): T[] => array.flatMap((f) => (f ? [f] : []));
